import * as types from "./actionType";
import * as HeaderAuthentication from '../HeaderAuthentication'
import { aiBaseUrl, baseURL } from "../BaseURL";
import Swal from "sweetalert2";
import { toast } from 'react-toastify';
import totalContactsIcon from '../../assets/images/dashboard/total-contacts.svg'


let headerAuth = HeaderAuthentication.getRequestOptions;

const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));

// region set screen region
export const setScreenZize = (screenWidth) => ({
    type: types.get_screen_width,
    payload: screenWidth,
})

export const setAIFreameWork = (aiFrameWork) => ({
    type: types.get_Ai_framework,
    payload: aiFrameWork,
})
// endregion

// sign up
export const getCountryCodeDropdown = (countryCodeDropdown) => ({
    type: types.get_CountryCode_Dropdown_Data,
    payload: countryCodeDropdown,
});
export const postSignUpData = () => ({
    type: types.post_SignUp_Data
})
// sign up

// sign in
export const postSignInData = () => ({
    type: types.post_SignIn_Data
})
export const getGeneratedToken = (getGeneratedToken) => ({
    type: types.get_Generated_Token,
    payload: getGeneratedToken,
});

export const validateGeneratedToken = (validateGeneratedToken) => ({
    type: types.validate_Generated_Token,
    payload: validateGeneratedToken,
});

export const getFirstLoginStatus = (loginStatus) => ({
    type: types.get_login_status,
    payload: loginStatus
})
// sign in

// #region dashboard page
const getSubscriptionuser = (subscribed_user) => ({
    type: types.get_subscribed_user_data,
    payload: subscribed_user
})
const getSubscriptionGrapg = (subscriber_graph_data) => ({
    type: types.get_subscriber_graph_data,
    payload: subscriber_graph_data
})
const getSubscriptionbyPlan = (subscriber_by_plan) => ({
    type: types.get_subscriber_by_plan,
    payload: subscriber_by_plan
})
const getRecentUsers = (recent_users) => ({
    type: types.get_recent_users,
    payload: recent_users
})
const getSessionLogins = (session_logins) => ({
    type: types.get_session_logins,
    payload: session_logins
})
const getApCreditData = (apollo_credit_data) => ({
    type: types.get_ap_credits,
    payload: apollo_credit_data
})

const getCounts = (totalCounts) => ({
    type: types.get_counts,
    payload: totalCounts
})
const getSubscriptions = (subscriptions) => ({
    type: types.get_subscription,
    payload: subscriptions
})
const getloginDetails = (loginDetails) => ({
    type: types.get_login_details,
    payload: loginDetails
})
const getUserActivityData = (userActivityData) => ({
    type: types.get_user_activity,
    payload: userActivityData
})
const getUserDownloadData = (userDownloadData) => ({
    type: types.get_download_activity,
    payload: userDownloadData
})
const getCountryGraph = (countryGraph) => ({
    type: types.get_country_graph,
    payload: countryGraph
})
const getMapGraph = (mapGraph) => ({
    type: types.get_map_graph,
    payload: mapGraph
})
const getIndustryGraph = (industryGraph) => ({
    type: types.get_industry_graph,
    payload: industryGraph
})
const getRecentSearch = (recentSearch) => ({
    type: types.get_recent_search,
    payload: recentSearch
})
const getCreditsData = (getCredits) => ({
    type: types.get_credits,
    payload: getCredits
})
const getUploadStatsBarchartData = (uploadStatsBarChartData) => ({
    type: types.get_Upload_Stats_BarChart_Data,
    payload: uploadStatsBarChartData
})
// #endregion

// #region upload pages
const getUploadData = (uploadedData) => ({
    type: types.get_upload_details,
    payload: uploadedData,
});
// #endregion

// search contacts
export const getJobLevelDropdownData = (jobLevelDropdown) => ({
    type: types.get_JobLevel_Dropdown,
    payload: jobLevelDropdown
});
export const getPreviousJobLevelDropdownData = (previousJobLevelDropdown) => ({
    type: types.get_preJobLevel_Dropdown,
    payload: previousJobLevelDropdown
});
export const getJobFunctionDropdownData = (jobFunctionDropdown) => ({
    type: types.get_Job_Function_Dropdown,
    payload: jobFunctionDropdown
})
export const getTechnologyDropdownData = (technologyDropdown) => ({
    type: types.get_Technology_Dropdown,
    payload: technologyDropdown
})
export const getPreviousTechnologyDropdownData = (previousTechnologyDropdown) => ({
    type: types.get_previousTechnology_Dropdown,
    payload: previousTechnologyDropdown
})
export const getSubIndustriesDropdownData = (subIndustriesDropdown) => ({
    type: types.get_SubIndustries_Dropdown,
    payload: subIndustriesDropdown
})
export const getPreviousSubIndustriesDropdownData = (previousSubIndustriesDropdown) => ({
    type: types.get_previousSubIndustry_Dropdown,
    payload: previousSubIndustriesDropdown
})
export const getCountryNameDropdownData = (countryNameDropdown) => ({
    type: types.get_CountryName_Dropdown,
    payload: countryNameDropdown
})
export const getSearchedContactData = (searchedContactData) => ({
    type: types.get_Searched_Contact_Data,
    payload: searchedContactData
})
export const getStateDropdownData = (stateDropdownData) => ({
    type: types.get_StateDropdown_BasedOnCountry,
    payload: stateDropdownData
})
export const getCityDropdownData = (cityDropdownData) => ({
    type: types.get_CityDropdown_BasedOnState,
    payload: cityDropdownData
})
export const getSearchContactData = () => ({
    type: types.get_Search_Contact_Data,
})
export const postSearchDataCount = () => ({
    type: types.post_Search_Data_Count
})
export const postPhoneUnlockData = () => ({
    type: types.post_Phone_Unlock_Data
})
export const getPhoneEmailUnlockedData = (phoneEmailUnlockedData) => ({
    type: types.get_Phone_Email_Unlocked_Data,
    payload: phoneEmailUnlockedData
})
export const getListNames = (getListName) => ({
    type: types.get_List_Name,
    payload: getListName
})
export const postSavedSearch = () => ({
    type: types.post_Save_Search_Data
})
export const getContinentsDropdown = (getContinents) => ({
    type: types.get_Continent_Dropdown,
    payload: getContinents
})
// search contacts

// viewed contacts
export const getViewedContactsData = (getViewedContacts) => ({
    type: types.get_Viewed_Contacts_Data,
    payload: getViewedContacts
})
export const getRecentContactsData = (getRecentContacts) => ({
    type: types.get_Recent_Contacts_Data,
    payload: getRecentContacts
})
export const getupdateViewedContactsData = (getViewedContacts) => ({
    type: types.get_Update_Viewed_Contacts,
    payload: getViewedContacts
})
export const downloadViewedContactsData = (downloadViewedData) => ({
    type: types.download_Viewed_Contacts_Data,
    payload: downloadViewedData
})
export const postDeleteViewedContactData = () => ({
    type: types.post_Delete_Viewed_Contacts_Data
})
export const unlockViewedContacts = (unlockAllContacts) => ({
    type: types.unlock_All_Contacts,
    payload: unlockAllContacts
})
// viewed contacts

// Settings Trash
export const getTrashedData = (trashedData) => ({
    type: types.get_Trashed_Data,
    payload: trashedData
})
export const restoreTrashData = () => ({
    type: types.restore_All_Data
})
export const deleteTrashData = () => ({
    type: types.delete_trashed_Data
})
// Settings Trash

// Saved Searches
export const getSavedSearchesData = (savedSearchData) => ({
    type: types.get_Saved_Searches_Data,
    payload: savedSearchData
})
export const EditSavedSearchData = () => ({
    type: types.edit_Saved_Searches_Data
})
export const deleteSavedSearchData = () => ({
    type: types.delete_Saved_Searches_Data
})
// Saved Searches

// Settings Users
export const getUsersData = (usersData) => ({
    type: types.get_Users_Data,
    payload: usersData
})
export const addUsersData = () => ({
    type: types.post_Users_Data
})
// Settings Users

// Report
// Data Count
export const getReportDataCountryCount = (reportDataCountryCount) => ({
    type: types.get_Report_Country_Data_Count,
    payload: reportDataCountryCount
})
export const getReportDataIndustryCount = (reportDataIndustryCount) => ({
    type: types.get_Report_Industry_Data_Count,
    payload: reportDataIndustryCount
})
export const getIndustryDropdown = (industryDropdown) => ({
    type: types.get_Industry_Dropdown,
    payload: industryDropdown
})
// Data Count
// Report

// #region get report page
const getReportsData = (getDataReport) => ({
    type: types.Get_Upload_Report,
    payload: getDataReport
})
const getUploadUsers = (getUploadUser) => ({
    type: types.get_upload_user,
    payload: getUploadUser
})
// #endregion

// Reset Password
export const resetPassword = () => ({
    type: types.post_Reset_Password_Data
})
// Reset Password

// Forgot Password
export const postForgotPasswordEmail = () => ({
    type: types.send_Forgot_Password_Email
})
// Forgot Password

// Profile
export const getProfileData = (profileData) => ({
    type: types.get_Profile_Data,
    payload: profileData
})
export const addAddressData = () => ({
    type: types.post_Profile_Data
})
// Profile

// My List
export const getMyListData = (myListData) => ({
    type: types.get_My_List_Data,
    payload: myListData,
});
export const editMyListData = () => ({
    type: types.update_My_List_Data
})
export const deleteMyList = () => ({
    type: types.delete_My_List_Data
})
// My List

// Total Data Count
export const getToataldataCount = (totalDataCount) => ({
    type: types.Get_Total_Data_Count,
    payload: totalDataCount,
});
// Total Data Count

// #region sign up
export const loadCountryCodeDropdown = () => {
    return function (dispatch) {
        fetch(`${baseURL}/api/location/getCountry`, HeaderAuthentication.getRequestOptions)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.items) {
                    dispatch(
                        getCountryCodeDropdown(
                            resp.items.map((data) => {
                                return { value: data.country_code, label: "+" + data.country_code + "(" + data.country_shortname + ")", country_name: data.country_name };
                            })
                        )
                    );
                }
                // setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const postSignUpUserData = (
    postRequest,
    hideSwal,
    email
) => {
    return function (dispatch) {
        return fetch(`${baseURL}/Users/register_user`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {

                // ✅ Sign-in logic for both 100 and 101
                if (resp.status === 100) {
                    if (!hideSwal) {
                        Swal.fire({
                            title: 'Success',
                            text: resp.message,
                            icon: 'success',
                            confirmButtonText: 'OK'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                window.location.href = "/";
                            }
                        });
                    }

                    if (hideSwal) {
                        const signInPostRequest = {
                            method: "POST",
                            mode: "cors",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({ email, "pswd": "" })
                        };

                        dispatch(postSignInUserData(signInPostRequest, hideSwal));
                        // navigate('/dashboard');
                        // window.location.reload();
                    }
                } else if (resp.status === 101) {
                    // alert(hideSwal)
                    if (!hideSwal) {
                        Swal.fire({
                            title: 'Warning',
                            text: resp.message,
                            icon: 'warning',
                        });
                    }

                    if (hideSwal) {
                        const signInPostRequest = {
                            method: "POST",
                            mode: "cors",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({ email, "pswd": "" })
                        };

                        dispatch(postSignInUserData(signInPostRequest, hideSwal));
                        // navigate('/dashboard');
                        // window.location.reload();
                    }
                } else {
                    // ❌ Failed response
                    const errorMessage = resp.message;
                    if (!hideSwal) {
                        Swal.fire({
                            title: 'Failed',
                            text: errorMessage,
                            icon: 'error',
                        });
                    }
                }

                return resp;
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

// #endregion

// #region sign in
export const postSignInUserData = (postRequest, hideSwal, to_email, user_name, phone, setPlanExpired, setExpireDetails) => {
    return function (dispatch) {
        const url = hideSwal ? `${baseURL}/lm_login/auth_login` : `${baseURL}/lm_login/user_sign_in`
        return fetch(url, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                console.log(resp, "login resp")
                if (resp.status === 100) {
                    if (setPlanExpired) {
                        setPlanExpired(false);
                    }
                    dispatch(postSignInData());

                    // Step 1: Generate token
                    const tokenUrl = `${baseURL}/lm_login/generate_token?email=${encodeURIComponent(resp?.data?.email)}&pswd=${encodeURIComponent(resp?.data?.passwd)}`;

                    fetch(tokenUrl)
                        .then(res => res.json())
                        .then(tokenResp => {
                            if (tokenResp.token) {
                                // Step 2: Validate token
                                const validateUrl = `${baseURL}/lm_login/token_validate?token=${encodeURIComponent(tokenResp.token)}`;

                                fetch(validateUrl)
                                    .then(res => res.json())
                                    .then(validateResp => {
                                        if (validateResp.status === 100) {
                                            // Store payload in sessionStorage
                                            console.log(validateResp.payload, "")
                                            if (validateResp?.payload?.first_login === "1") {
                                                sessionStorage.setItem("firstLogin", true);
                                            } else {
                                                sessionStorage.setItem("firstLogin", false);
                                            }
                                            sessionStorage.setItem("SignInDetails", JSON.stringify([validateResp.payload]));
                                            sessionStorage.setItem("login", true);
                                            toast.success("Logged in successfully!");

                                            // navigate("/dashboard");
                                            // window.location.reload();
                                            window.location.href = "/";
                                        } else {
                                            toast.error(validateResp.message || "Token validation failed");
                                        }
                                    })
                                    .catch((err) => {
                                        console.error("Validation error:", err);
                                        toast.error("Error during token validation");
                                    });
                            } else {
                                toast.error(tokenResp.message || "Failed to generate token");
                            }
                        })
                        .catch((err) => {
                            console.error("Token error:", err);
                            toast.error("Token generation failed");
                        });

                } else if (resp.status === 102) {
                    if (hideSwal) {
                        const signInPostRequest = {
                            method: "POST",
                            mode: "cors",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                user_name,
                                to_email,
                                "mobile_code": "",
                                phone,
                                "company_name": "",
                            })
                        };

                        dispatch(postSignUpUserData(signInPostRequest, hideSwal, to_email));
                    }
                    toast.error(resp.message || "Login failed");
                    // navigate('/dashboard');
                } else if (resp.status === 403) {
                    if (setPlanExpired) {
                        setPlanExpired(true);
                    }

                    sessionStorage.setItem("plan_expired", true);

                    setExpireDetails(resp.encrypted);
                    const tokenUrl = `${baseURL}/lm_login/generate_token?email=${encodeURIComponent(resp?.data?.email)}&pswd=${encodeURIComponent(resp?.data?.passwd)}`;

                    fetch(tokenUrl)
                        .then(res => res.json())
                        .then(tokenResp => {
                            if (tokenResp.token) {
                                // Step 2: Validate token
                                const validateUrl = `${baseURL}/lm_login/token_validate?token=${encodeURIComponent(tokenResp.token)}`;

                                fetch(validateUrl)
                                    .then(res => res.json())
                                    .then(validateResp => {
                                        if (validateResp.status === 100) {
                                            // Store payload in sessionStorage
                                            console.log(validateResp.payload, "")
                                            if (validateResp?.payload?.first_login === "1") {
                                                sessionStorage.setItem("firstLogin", true);
                                            } else {
                                                sessionStorage.setItem("firstLogin", false);
                                            }
                                            sessionStorage.setItem("SignInDetails", JSON.stringify([validateResp.payload]));
                                            sessionStorage.setItem("login", true);
                                            toast.success("Logged in successfully!");

                                            // navigate("/dashboard");
                                            // window.location.reload();
                                            window.location.href = "/";
                                        } else {
                                            toast.error(validateResp.message || "Token validation failed");
                                        }
                                    })
                                    .catch((err) => {
                                        console.error("Validation error:", err);
                                        toast.error("Error during token validation");
                                    });
                            } else {
                                toast.error(tokenResp.message || "Failed to generate token");
                            }
                        })
                        .catch((err) => {
                            console.error("Token error:", err);
                            toast.error("Token generation failed");
                        });
                } else {
                    toast.error(resp.message || "Login failed");
                }

                return resp;
            })
            .catch((err) => {
                console.error("Login request failed:", err);
                toast.error("Network or server error");
            });
    };
};
// #endregion

// sign in
// export const postSignInUserData = (postRequest, hideSwal, to_email, user_name, phone) => {
//     return function (dispatch) {
//         const url = hideSwal
//             ? `${baseURL}/lm_login/auth_login`
//             : `${baseURL}/lm_login/user_sign_in`;

//         fetch(url, postRequest)
//             .then((resp) => resp.json())
//             .then((resp) => {
//                 if (resp.status === 100 || resp.status === 403) {
//                     // ✅ Successful login
//                     if(resp.status === 403){
//                         sessionStorage.setItem("expiryStatus", true);
//                     }
//                     dispatch(postSignInData());


//                     const tokenUrl = `${baseURL}/lm_login/generate_token?email=${encodeURIComponent(
//                         resp?.data?.email
//                     )}&pswd=${encodeURIComponent(resp?.data?.passwd)}`;

//                     fetch(tokenUrl)
//                         .then((res) => res.json())
//                         .then((tokenResp) => {
//                             if (tokenResp.token) {
//                                 const validateUrl = `${baseURL}/lm_login/token_validate?token=${encodeURIComponent(
//                                     tokenResp.token
//                                 )}`;

//                                 fetch(validateUrl)
//                                     .then((res) => res.json())
//                                     .then((validateResp) => {
//                                         if (validateResp.status === 100) {
//                                             // ✅ Store user session
//                                             sessionStorage.setItem(
//                                                 "SignInDetails",
//                                                 JSON.stringify([validateResp.payload])
//                                             );
//                                             sessionStorage.setItem("login", true);

//                                             toast.success("Logged in successfully!");
//                                             // 🔁 reload or navigate to dashboard
//                                             window.location.reload();
//                                             // navigate('/dashboard'); // optional alternative
//                                         } else {
//                                             toast.error(
//                                                 validateResp.message || "Token validation failed"
//                                             );
//                                         }
//                                     })
//                                     .catch((err) => {
//                                         console.error("Validation error:", err);
//                                         toast.error("Error during token validation");
//                                     });
//                             } else {
//                                 toast.error(tokenResp.message || "Failed to generate token");
//                             }
//                         })
//                         .catch((err) => {
//                             console.error("Token error:", err);
//                             toast.error("Token generation failed");
//                         });
//                 } 
//                 else if (resp.status === 102) {
//                     // ⚙️ Auto-signup if user doesn't exist (Google/LinkedIn case)
//                     if (hideSwal) {
//                         const signInPostRequest = {
//                             method: "POST",
//                             mode: "cors",
//                             headers: {
//                                 "Content-Type": "application/json",
//                             },
//                             body: JSON.stringify({
//                                 user_name,
//                                 to_email,
//                                 "mobile_code": "",
//                                 phone,
//                                 "company_name": "",
//                             }),
//                         };
//                         dispatch(postSignUpUserData(signInPostRequest, hideSwal, to_email));
//                     }
//                     toast.error(resp.message || "Login failed");
//                 } 
//                 else {
//                     // ✅ Always allow login attempt — no plan expiration logic
//                     toast.error(resp.message || "Login failed");
//                 }
//             })
//             .catch((err) => {
//                 console.error("Login request failed:", err);
//                 toast.error("Network or server error");
//             });
//     };
// };

// sign in


// #region dashboard page
export const loadGetSubscription = () => {
    return function (dispatch) {
        return fetch(`${baseURL}/dashboard/subscribed_user_data`, headerAuth)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 200) {
                    dispatch(getSubscriptionuser(resp.data))
                    return resp
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}


export const loadGetSubscriptionGraph = (duration) => {
    return function (dispatch) {
        return fetch(`${baseURL}/dashboard/subscription_graph?duration=${duration}`, headerAuth)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 200) {
                    dispatch(getSubscriptionGrapg(resp.data))
                    return resp
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}

export const loadGetSubscriptionByPlan = () => {
    return function (dispatch) {
        return fetch(`${baseURL}/dashboard/subscription_by_plan`, headerAuth)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 200) {
                    dispatch(getSubscriptionbyPlan(resp.data))
                    return resp
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}

export const loadRecentUsers = () => {
    return function (dispatch) {
        return fetch(`${baseURL}/dashboard/get_recent_subscription`, headerAuth)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 200) {
                    dispatch(getRecentUsers(resp.data))
                    return resp
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}

export const loadSessionLogins = () => {
    return function (dispatch) {
        return fetch(`${baseURL}/dashboard/current_session_login`, headerAuth)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 200) {
                    dispatch(getSessionLogins(resp.login_activity))
                    return resp
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}

export const loadApCreditData = () => {
    return function (dispatch) {
        return fetch(`${aiBaseUrl}apolo_api/api_profile`, headerAuth)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 200) {
                    dispatch(getApCreditData(resp.data))
                    return resp
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}

// #region get total count api
export const loadTotalCounts = () => {
    return function (dispatch) {
        fetch(`${baseURL}/dashboard/get_total_counts`, headerAuth)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 100) {
                    const get_data = resp.data;
                    const dashboardData = [
                        { title: 'Total Count', count: get_data.total_contacts, icon: totalContactsIcon },
                        { title: 'Country', count: get_data.country_count, icon: totalContactsIcon },
                        { title: 'Industries', count: get_data.industry_count, icon: totalContactsIcon },
                        { title: 'Job Title', count: get_data.job_title_count, icon: totalContactsIcon },
                        { title: 'Technology', count: get_data.technology_count, icon: totalContactsIcon }
                    ];
                    dispatch(getCounts(dashboardData));
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}
// #endregion

// #region get subsription
export const loadSubscriptions = () => {
    return function (dispatch) {
        fetch(`${baseURL}/dashboard/get_subscription`, headerAuth)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.items) {
                    dispatch(getSubscriptions(resp.items));
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}
// #endregion

// #region get login details
export const loadloginDetails = () => {
    return function (dispatch) {
        fetch(`${baseURL}/dashboard/get_login_details`, headerAuth)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 100) {
                    dispatch(getloginDetails(resp.data));
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}
// #endregion

// #region get user activity
export const loadUserActivityData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/dashboard/get_user_activity_data`, headerAuth)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 100) {
                    dispatch(getUserActivityData(resp.data));
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}
// #endregion

// #region get user activity
export const loadUserDownloadData = () => {
    return function (dispatch) {
        fetch(`${baseURL}/dashboard/get_download_activity_data?user_id=${parseInt(signInDetails[0].id)}&sbn_id=${signInDetails[0].sbn_id}&role=${signInDetails[0].role}`, headerAuth)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 100) {
                    dispatch(getUserDownloadData(resp.data));
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}
// #endregion

// #region get country graph
export const loadCountryGraph = (type) => {
    return function (dispatch) {
        let limit = 10;
        if (type === "map") {
            limit = 200
        }
        fetch(`${baseURL}/dashboard/get_country_wise_count?page=1&limit=${limit}`, headerAuth)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 100) {
                    if (type === "map") {
                        dispatch(getMapGraph(resp.data))
                    } else {
                        dispatch(getCountryGraph(resp.data));
                    }
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}
// #endregion

// #region get country graph
export const loadIndustryGraph = () => {
    return function (dispatch) {
        fetch(`${baseURL}/dashboard/get_industry_wise_count?page=1&limit=10`, headerAuth)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 100) {
                    dispatch(getIndustryGraph(resp.data));
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
}
// #endregion

// #region get user activity
export const loadRecentSearch = () => {
    return function (dispatch) {
        fetch(`${baseURL}/dashboard/get_recent_search?user_id=${parseInt(signInDetails[0].id)}&sbn_id=${signInDetails[0].sbn_id}&role=${signInDetails[0].role}&page=1&limit=10`, headerAuth)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 100) {
                    dispatch(getRecentSearch(resp.data));
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
}
// #endregion

// #region get user activity
export const loadCreditsData = (sbn_id, user_id) => {
    return function (dispatch) {
        fetch(`${baseURL}/Users/get_account_details?sbn_id=${sbn_id}&fk_user_id=${user_id}`, headerAuth)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 100) {
                    dispatch(getCreditsData(resp.data));
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
}
export const loadUploadsStatsBarChartData = (timeRange) => {
    return function (dispatch) {
        fetch(`${baseURL}/dashboard/upload_graph_view?time_range=${timeRange}`, headerAuth)
            .then((resp) => resp.json())
            .then((resp) => {
                console.log(resp, 'resp')
                if (resp.status === '100') {
                    dispatch(getUploadStatsBarchartData(resp.data));
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
}
// #endregion
// #endregion

// #region upload page
// #region get uploads
export const getAllUploads = (limit, pageSize, role, sbnId, usrId, get_uplaoads, setLoadingMore) => {
    return function (dispatch) {
        fetch(`${baseURL}/uploads/get_uploaded_data?limit=${limit}&page=${pageSize}&role=${role}&sbn_id=${sbnId}&user_id=${usrId}`, headerAuth)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status === 100) {
                    dispatch(getUploadData([...get_uplaoads, ...resp.data]));
                    dispatch(getToataldataCount(resp.total_count))
                    setLoadingMore(false)
                } else {
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}
// #endregion

// #region upload csv file
export const loadUploadCsv = (postRequest, close_Model, setIsCompleted, setIsError) => {
    return function (dispatch) {
        fetch(`${baseURL}/uploads/upload_contacts_csv?user_id=${parseInt(signInDetails[0].id)}&username=${signInDetails[0].name}&sbn_id=${signInDetails[0].sbn_id}&uploaded_role=${signInDetails[0].role}&uploaded_from=leadmerge_b2b`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status === 100) {
                    // close_Model();
                    setIsCompleted(true)
                    toast.success(`${resp.message}`);
                    dispatch(getAllUploads());
                } else if (resp.status === 404) {
                    setIsCompleted(true)
                    // close_Model();
                    toast.warning(`${resp.message}`);
                    dispatch(getAllUploads());
                } else if (resp.status === 400) {
                    // setIsCompleted(true)
                    setIsError(true)
                    toast.error(`${resp.message} - ${resp.missing_columns}`)
                } else {
                    setIsError(true)
                    toast.success(`${resp.message}`);
                    // toast.error(`${resp.message} - ${resp.missing_columns}`)
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                setIsCompleted(true)
                setIsError(true)
                toast.error(`${err}`)
            });
    }
}
// #endregion

// #region download file
export const loadDownlodFiles = (upload_id, file_name) => {
    return function (dispatch) {
        fetch(`${baseURL}/uploads/download_csv_file?UPLOAD_ID=${upload_id}&FILE_NAME=${file_name}`, headerAuth)
            .then((resp) => resp.blob())
            .then((resp) => {
                console.log(resp)
                const url = window.URL.createObjectURL(resp);
                const a = document.createElement('a');
                a.href = url;
                a.download = file_name;  // Ensure file_name has `.csv` extension
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
            })
            .catch((err) => {
                // toast.error(`${err}`);
                toast.error(`${err}`)
            });
    }
}
// #endregion

// #region get progress api
export const loadProgress = (isStarted, setIsStarted, setProgress, setVerientColor) => {
    return function (dispatch) {
        fetch(`${baseURL}/uploads/upload_progress`, headerAuth)
            .then((resp) => resp.json())
            .then((resp) => {
                console.log(resp);
                if (resp.status === 100) {
                    setProgress(resp.data?.percentage)
                    if (resp.data?.percentage < 20) {
                        setVerientColor('warning')
                    } else if (resp.data?.percentage < 50) {
                        setVerientColor('info')
                    } else if (resp.data?.percentage < 90) {
                        setVerientColor('primary')
                    } else {
                        setVerientColor('success')
                    }
                    if (!isStarted) {
                        setIsStarted(true)
                    } else if (isStarted && resp.data?.percentage === 100) {
                        setIsStarted(false)
                    }
                }
            })
            .catch((err) => {
                toast.error(`${err}`)
            });
    }
}
// #endregion
// #endregion

// search contacts
export const loadJobLevelDropdown = (filterValue = "", setLoadingJobLevels, type, page, pageSize, existingOptions = []) => {
    return function (dispatch) {
        setLoadingJobLevels(true);
        const queryParam = filterValue.trim() === "" ? "" : `?filter_value=${encodeURIComponent(filterValue)}&page_number=${page}&page_size=${pageSize}`;
        fetch(`${baseURL}/contact_search/job_level_dropdown${queryParam}`, HeaderAuthentication.getRequestOptions)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.data) {
                    const newOptions = resp.data.map(data => ({
                        value: data.JOB_LEVEL,
                        label: data.JOB_LEVEL
                    }));

                    if (type === 'search') {
                        dispatch(getPreviousJobLevelDropdownData(newOptions))
                        dispatch(getToataldataCount(resp.total_count))
                        setLoadingJobLevels(false)
                    } else {
                        const combined = [...existingOptions, ...newOptions];
                        dispatch(getJobLevelDropdownData(combined))
                        dispatch(getToataldataCount(resp.total_count))
                        setLoadingJobLevels(false)
                    }
                } else {
                    dispatch(getJobLevelDropdownData([]));
                }
            })
            .catch((err) => { console.log(err) });
    };
};
// export const loadJobFunctionDropdown = (jobLevels = null) => {
//     return function (dispatch) {
//         const requestBody = jobLevels && jobLevels.length > 0
//             ? JSON.stringify({ job_levels: jobLevels })
//             : JSON.stringify({ job_levels: null });

//         fetch(`${baseURL}/contact_search/job_function_dropdown`, HeaderAuthentication.postAuthOfLeadMerge,{
//                 body: requestBody,
//             })
//             .then((resp) => resp.json())
//             .then((resp) => {
//                 console.log(resp,'resp')
//                 if (resp.data) {
//                     dispatch(
//                         getJobFunctionDropdownData(
//                             resp.data.map((data) => ({
//                                 value: data.JOB_DEPARTMENT,
//                                 label: data.JOB_DEPARTMENT,
//                             }))
//                         )
//                     );
//                 }
//             })
//             .catch((err) => {
//                 console.log("Error fetching job functions:", err);
//             });
//     };
// };
export const loadJobFunctionDropdown = (jobLevels = null, setLoading) => {
    return function (dispatch) {
        if (setLoading) setLoading(true);

        // Prepare the request body
        const requestBody = jobLevels && jobLevels.length > 0
            ? JSON.stringify({ job_levels: jobLevels })
            : JSON.stringify({ job_levels: null });

        fetch(`${baseURL}/contact_search/job_function_dropdown`, {
            method: 'POST', // Specify the method
            headers: {
                'Content-Type': 'application/json',
                ...HeaderAuthentication.postAuthOfLeadMerge.headers,  // Spread the headers here
            },
            body: requestBody, // Pass the request body
        })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.data) {
                    dispatch(
                        getJobFunctionDropdownData(
                            resp.data.map((data) => ({
                                value: data.JOB_DEPARTMENT,
                                label: data.JOB_DEPARTMENT,
                            }))
                        )
                    );
                } else {
                    dispatch(getJobFunctionDropdownData([]));
                }
                setLoading(false);
            })
            .catch((err) => {
                console.log('Error fetching job functions:', err);
            });
    };
};
export const loadTechnologyDropdown = (filterValue = "", setLoadingTechnologies, type) => {
    const queryParam = filterValue.trim() === "" ? "" : `?filter_value=${encodeURIComponent(filterValue)}`;
    return function (dispatch) {
        if (setLoadingTechnologies) setLoadingTechnologies(true);
        fetch(`${baseURL}/contact_search/technology_dropdown${queryParam}`, HeaderAuthentication.getRequestOptions)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.data) {
                    if (type === 'search') {
                        dispatch(getPreviousTechnologyDropdownData(
                            resp.data.map((data) => {
                                return { value: data.TECHNOLOGY, label: data.TECHNOLOGY };
                            })
                        ))
                    } else {
                        dispatch(
                            getTechnologyDropdownData(
                                resp.data.map((data) => {
                                    return { value: data.TECHNOLOGY, label: data.TECHNOLOGY };
                                })
                            )
                        );
                    }
                } else {
                    dispatch(getTechnologyDropdownData([]));
                }
                setLoadingTechnologies(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadSubIndustriesDropdown = (type, filterValue = "", setLoadingSubIndustries, page, pageSize, setTotalCount, existingData, setFetchedLength, fetchedDataLength) => {
    // const queryParam = filterValue.trim() === "" ? "" : `?filter_value=${encodeURIComponent(filterValue)}`;
    const queryParam = (filterValue && filterValue.trim() === "") ? "" : `?type=${type}&filter_value=${encodeURIComponent(filterValue)}&page_number=${page}&page_size=${pageSize}`;
    return function (dispatch) {
        if (setLoadingSubIndustries) setLoadingSubIndustries(true);
        fetch(`${baseURL}/contact_search/industry_dropdown${queryParam}`, HeaderAuthentication.getRequestOptions)
            .then((resp) => resp.json())
            .then((resp) => {
                const subIndustries = resp.data.flatMap((industry) =>
                    industry.sub_industry.map((subIndustry) => ({
                        value: subIndustry,
                        label: subIndustry, // Include industry name in label
                        industry: industry.industry // Store the industry name as a separate field
                    }))
                );

                // Append new sub-industries to existing data
                const updatedData = [...existingData, ...subIndustries];

                // Dispatch the formatted sub-industry data
                if (type === 'search') {
                    dispatch(getPreviousSubIndustriesDropdownData(subIndustries));
                } else {
                    dispatch(getSubIndustriesDropdownData(updatedData));
                    setTotalCount(resp.total_count);
                    if (setFetchedLength) {
                        let dataLength = parseInt(fetchedDataLength) + parseInt(resp.data?.length);
                        setFetchedLength(dataLength)
                    }
                    setLoadingSubIndustries(false);
                }
                // dispatch(getToataldataCount(resp.total_count))

            })
            .catch((err) => { console.log(err) });
    };
};

export const loadCountryNameDropdown = () => {
    return function (dispatch) {
        fetch(`${baseURL}/api/location/getCountry`, HeaderAuthentication.getRequestOptions)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.items) {
                    dispatch(
                        getCountryNameDropdownData(
                            resp.items.map((data) => {
                                return {
                                    value: data.country_id,
                                    label: data.country_name,
                                    code: data.country_code,
                                    shortname: data.country_shortname,
                                };
                            })
                        )
                    );
                }
                // setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadStateNameDropdown = (countryIdStr = null, stateName = null) => {
    return function (dispatch) {
        const params = new URLSearchParams();

        if (countryIdStr) {
            // Directly append the country IDs without encoding
            params.append('country_id', countryIdStr);
        } else if (stateName) {
            params.append('state_name', stateName);
        }

        // Convert URLSearchParams to string and replace '%2C' with ',' (decode commas)
        let url = `${baseURL}/api/location/getState?${params.toString()}`;
        url = url.replace(/%2C/g, ',');  // Log the final URL
        fetch(url, HeaderAuthentication.getRequestOptions)

            // fetch(`${baseURL}/api/location/getState?${params.toString()}`, HeaderAuthentication.getRequestOptions)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.data) {
                    dispatch(
                        getStateDropdownData(
                            resp.data.map((data) => {
                                return {
                                    value: data.state_id,
                                    label: data.state_name,
                                    // shortname: data.state_shortname,
                                    countryId: data.country_id,
                                };
                            })
                        )
                    );
                }
                // setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const loadCityNameDropdown = (stateIdStr = null, cityName = null) => {
    return function (dispatch) {
        const params = new URLSearchParams();

        if (stateIdStr) {
            // Directly append the country IDs without encoding
            params.append('states_id', stateIdStr);
        } else if (cityName) {
            params.append('city_name', cityName);
        }

        // Convert URLSearchParams to string and replace '%2C' with ',' (decode commas)
        let url = `${baseURL}/api/location/getCities?${params.toString()}`;
        url = url.replace(/%2C/g, ',');
        fetch(url, HeaderAuthentication.getRequestOptions)
            // fetch(`${baseURL}/api/location/getState?${params.toString()}`, HeaderAuthentication.getRequestOptions)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.data) {
                    dispatch(
                        getCityDropdownData(
                            resp.data.map((data) => {
                                return {
                                    value: data.city_id,
                                    label: data.city_name,
                                };
                            })
                        )
                    );
                }
                // setLoading(false);
            })
            .catch((err) => { console.log(err) });
    };
};
export const postSearchDataCounts = (
    postRequest,
    setTotalCount,
    setEncriptScenario,
    setCountryStates,
    setLoading,
    setBodyEncrypted,
    controller // 👈 received from useEffect
) => {
    return function (dispatch) {
        fetch(`${baseURL}/contact_search/get_total_count`,
            {
                ...postRequest,
                signal: controller.signal
            })
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status === 100) {
                    dispatch(postSearchDataCount());
                    dispatch(getToataldataCount(resp.total_count))
                    setTotalCount(resp.total_count);
                    setEncriptScenario(resp.encript_scenario);
                    setBodyEncrypted(resp.body_encripted);
                    setCountryStates(resp.country_states);
                    setLoading(false);
                    // cancelModal();
                } else {
                    toast.error(resp.Error);
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                // console.log(err);
                if (err.name === "AbortError") {
                    console.log("Previous request aborted ✅");
                } else {
                    toast.error(`${err}`);
                    console.log(err);
                }
            });
    }
}
export const loadSearchContactData = (
    postRequest,
    setSearchedContactData,
    setLoading,
    setResponseTime,
    startTime,
    setLoadingMore,
    previousData = [],
) => {
    return function (dispatch) {
        fetch(`${baseURL}/contact_search/get_searched_data`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                const endTime = Date.now(); // Capture end time
                const duration = endTime - startTime; // Milliseconds
                setResponseTime(duration);  // ⬅️ Store duration
                if (resp.success_code === 100) {
                    dispatch(getSearchContactData());
                    // const combined = [...previousData, ...resp.data]
                    // setSearchedContactData(combined);
                    const combinedMap = new Map();

                    // Add previous data first
                    previousData.forEach((item) => {
                        combinedMap.set(item.id, item); // Use `id` to uniquely identify
                    });

                    // Overwrite/add new data from response
                    resp.data.forEach((item) => {
                        combinedMap.set(item.id, item);
                    });

                    // Final unique array
                    const dedupedData = Array.from(combinedMap.values());

                    setSearchedContactData(dedupedData);


                    setLoading(false);
                    setLoadingMore(false);
                } else {
                    toast.error(resp.Error);
                }
            })
            .catch((err) => {
                toast.error(`${err}`);
                console.log(err);
            });
    }
}
export const postPhoneUnlockDatas = (
    postRequest,
    type,
    fetchSearchContact
    // closeModal
) => {
    return function (dispatch) {
        fetch(`${baseURL}/view_contacts/add_viewed_contacts`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.success_code === 100) {
                    dispatch(postPhoneUnlockData());
                    setTimeout(() => {
                        fetchSearchContact()
                    }, 2000);
                    // closeModal();
                    if (type === 'phone') {
                        toast.success("Phone Unlocked!");
                    } else if (type === 'email') {
                        toast.success("Email Unlocked!");
                    } else {
                        Swal.fire({
                            title: 'Success',
                            text: 'The list has been created successfully',
                            icon: 'success',
                        });
                    }

                } else if (resp.success_code === 403) {
                    toast.warning(resp.message);
                }
                else {
                    toast.error(resp.message);
                }
            })
            .catch((err) => {
                toast.error(`${err}`);
                console.log(err);
            });
    }
}


export const loadPhoneEmailUnlockedData = (id, sbnId) => {
    return function (dispatch) {
        fetch(`${baseURL}/view_contacts/get_viewed_contacts?user_id=${id}&sbn_id=${sbnId}`,
            HeaderAuthentication.getRequestOptions)
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getPhoneEmailUnlockedData(resp.data))
            })
            .catch((err) => {
                toast.error(`${err}`);
                console.log(err);
            });
    }
}
export const loadListNameDropdown = (id, sbnId) => {
    return function (dispatch) {
        fetch(`${baseURL}/lists/get_user_lists?fk_user_id=${id}&sbn_id=${sbnId}`,
            HeaderAuthentication.getRequestOptions)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.data) {
                    dispatch(
                        getListNames(
                            resp.data.map((data) => {
                                return {
                                    value: data.list_name,
                                    label: data.list_name,
                                };
                            })
                        )
                    );
                }
                else {
                    dispatch(getListNames([]));
                }
            })
            .catch((err) => {
                toast.error(`${err}`);
                console.log(err);
            });
    }
}
export const postSaveSearchData = (postRequest, cancelModal) => {
    return function (dispatch) {
        fetch(`${baseURL}/contact_search/save_search`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 100) {
                    dispatch(postSavedSearch());
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.message,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.message; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}
export const loadContinentsDropdown = () => {
    return function (dispatch) {
        fetch(`${baseURL}/api/location/getContinents`, HeaderAuthentication.getRequestOptions)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.Continents && Array.isArray(resp.Continents)) {
                    const dropdownData = resp.Continents.map((continent) => {
                        return {
                            label: continent.Continent,           // Continent name as label
                            value: (continent.Countries || [])    // Array of country names
                                .map(c => c.value)      // Use the 'value' field from each country
                                .filter(Boolean)        // Remove any null/undefined
                        };
                    });

                    dispatch(getContinentsDropdown(dropdownData));
                } else {
                    dispatch(getContinentsDropdown([]));
                }
            })
            .catch((err) => {
                toast.error(`${err}`);
                console.error("API Error:", err);
            });
    };
};
// search contacts

// viewed contacts
export const loadRecentContactsData = (id, sbnId, Default, role, page, limit) => {
    return function (dispatch) {

        fetch(`${baseURL}/view_contacts/recently_viewed_contacts?user_id=${id}&sbn_id=${sbnId}&list_name=${Default}&role=${role}&page=${page}&limit=${limit}`,
            HeaderAuthentication.getRequestOptions)
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getRecentContactsData(resp.data))
            })
            .catch((err) => {
                toast.error(`${err}`);
                console.log(err);
            });
    }
}

export const loadViewedContactsData = (id, sbnId, Default, role, page, limit, setLoading, setLoadingMore, selectFilter) => {
    return function (dispatch) {
        let endpoint = "All"
        if (selectFilter.value === "Enriched") {
            endpoint = "get_enriched_contacts"
        } else if (selectFilter.value === "Locked") {
            endpoint = "get_locked_contacts"
        } else {
            endpoint = "get_viewed_contacts"
        }

        fetch(`${baseURL}/view_contacts/${endpoint}?user_id=${id}&sbn_id=${sbnId}&list_name=${Default}&role=${role}&page=${page}&limit=${limit}`,
            HeaderAuthentication.getRequestOptions)
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getViewedContactsData(resp.data))
                dispatch(getToataldataCount(resp.total_count))
                setLoading(false)
                if (setLoadingMore) {
                    setLoadingMore(false)
                }
            })
            .catch((err) => {
                setLoading(false)
                if (setLoadingMore) {
                    setLoadingMore(false)
                }
                toast.error(`${err}`);
                console.log(err);
            });
    }
}
export const downloadViewedContactsDatas = (postDownloadData, setDownloading) => {
    return function (dispatch) {
        fetch(`${baseURL}/view_contacts/download_viewed_contacts`,
            postDownloadData)
            // .then((resp) => resp.blob())
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.success_code === 200) {
                    const items = resp.items || [];

                    if (!items.length) {
                        toast.warning(`No data found. Please try again..!`);
                        setDownloading(false);
                        return;
                    }

                    const headers = Object.keys(items[0]);

                    const csvRows = [
                        headers.join(","),
                        ...items.map(row =>
                            headers.map(field => {
                                const value = row[field] ?? "";
                                return `"${String(value).replace(/"/g, '""')}"`;
                            }).join(",")
                        )
                    ];

                    const csvString = csvRows.join("\n");

                    const blob = new Blob([csvString], {
                        type: "text/csv;charset=utf-8;"
                    });

                    const url = window.URL.createObjectURL(blob);

                    const a = document.createElement("a");
                    a.href = url;
                    a.download = "ViewedContacts.csv";

                    document.body.appendChild(a);
                    a.click();

                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(url);
                } else {
                    toast.warning(`Contact not downloaded. Please try again..!`);
                }

                setDownloading(false);
                // fetchViewedContact();
            })
            .catch((err) => {
                toast.error(`${err}`);
                console.log(err);
            });
    }
}
export const selectedDowloadContactsDatas = (postRequest, setDownloading, fetchViewedContact) => {
    return function (dispatch) {
        fetch(`${baseURL}/view_contacts/download_selected_contacts`,
            postRequest)
            .then((resp) => resp.blob())
            .then((resp) => {
                console.log(resp)
                const url = window.URL.createObjectURL(resp);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'ViewedContacts.csv';  // Ensure file_name has `.csv` extension
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
                setDownloading(false);
                fetchViewedContact(1);
            })
            .catch((err) => {
                toast.error(`${err}`);
                console.log(err);
            });
    }
}

export const postDeleteViewedContactsData = (
    postRequest,
    fetchViewedContact,
    clearSelection
) => {
    return function (dispatch) {
        fetch(`${baseURL}/trash/add_trashed`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.success_code === 100) {
                    dispatch(postDeleteViewedContactData());
                    // cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.message,
                        icon: 'success',
                    });
                    fetchViewedContact(1);
                    clearSelection();
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.message; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}

export const unlockAllViewedContacts = (id, sbnId, Default, role, fetchViewedContact) => {
    return function (dispatch) {
        fetch(`${baseURL}/view_contacts/unlock_all_contacts?user_id=${id}&sbn_id=${sbnId}&list_name=${Default}&role=${role}`,
            HeaderAuthentication.getRequestOptions)
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(unlockViewedContacts(resp.data));
                Swal.fire({
                    title: 'Success',
                    text: resp.message,
                    icon: 'success',
                });
                fetchViewedContact();
            })
            .catch((err) => {
                toast.error(`${err}`);
                console.log(err);
            });
    }
}
// viewed contacts

// Settings Trash
export const loadTrashedData = (id, sbnId, Default, role, page, limit, setLoading) => {
    return function (dispatch) {
        setLoading(true);
        fetch(`${baseURL}/trash/get_trashed?user_id=${id}&sbn_id=${sbnId}&list_name=${Default}&role=${role}&page=${page}&limit=${limit}`,
            HeaderAuthentication.getRequestOptions)
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getTrashedData(resp.data))
                dispatch(getToataldataCount(resp.total_count))
                setLoading(false)
            })
            .catch((err) => {
                toast.error(`${err}`);
                console.log(err);
            });
    }
}

export const restoreTrashedData = (
    postRequest,
    fetchTashedData,
    clearSelection
) => {
    return function (dispatch) {
        fetch(`${baseURL}/trash/restore_contacts`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 100) {
                    dispatch(restoreTrashData());
                    // cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.message,
                        icon: 'success',
                    });
                    fetchTashedData()
                    clearSelection();
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.message; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}
export const deleteTrashedData = (
    postRequest,
    fetchTashedData,
    clearSelection
) => {
    return function (dispatch) {
        fetch(`${baseURL}/trash/delete_conatacts`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 100) {
                    dispatch(deleteTrashData());
                    // cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.message,
                        icon: 'success',
                    });
                    fetchTashedData();
                    clearSelection();
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.message; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}
// Settings Trash

// Saved Searches
export const loadSavedSearches = (id, sbnId, setLoading) => {
    return function (dispatch) {
        setLoading(true);
        fetch(`${baseURL}/contact_search/get_saved_searches?fk_user_id=${id}&sbn_id=${sbnId}`,
            HeaderAuthentication.getRequestOptions)
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getSavedSearchesData(resp.data))
                dispatch(getToataldataCount(resp.total_count))
                setLoading(false)
            })
            .catch((err) => {
                toast.error(`${err}`);
                console.log(err);
            });
    }
}
export const updateSavedSearchData = (
    postRequest,
    fetchSavedSearches,
    cancelModal
) => {
    return function (dispatch) {
        fetch(`${baseURL}/contact_search/edit_saved_name`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 100) {
                    dispatch(EditSavedSearchData());
                    fetchSavedSearches();
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.message,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.message; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}
export const deleteSavedSearchDatas = (
    postRequest,
    fetchSavedSearches,
    cancelModal
) => {
    return function (dispatch) {
        fetch(`${baseURL}/contact_search/delete_saved_search`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 100) {
                    dispatch(deleteSavedSearchData());
                    fetchSavedSearches();
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.message,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.message; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}
// Saved Searches

// Settings Users
export const loadUsersData = (sbnId, role, setLoading) => {
    return function (dispatch) {
        setLoading(true);
        fetch(`${baseURL}/Users/get_users?sbn_id=${sbnId}&role=${role}`,
            HeaderAuthentication.getRequestOptions)
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getUsersData(resp.data))
                dispatch(getToataldataCount(resp.total_count))
                setLoading(false)
            })
            .catch((err) => {
                toast.error(`${err}`);
                console.log(err);
            });
    }
}
export const postAddUsersData = (
    postRequest,
    fetchUsersData,
    cancelModal
) => {
    return function (dispatch) {
        fetch(`${baseURL}/Users/add_user`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status === 100) {
                    dispatch(addUsersData());
                    fetchUsersData();
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.message,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.message; // Extract error message
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}
// Settings Users

// Report
// Data Count
export const loadReportCountryCountData = (id, country, startDate, endDate, page, limit, setLoading, setLoadingMore, reportDataCountryCount = [], setUploadCount) => {
    return function (dispatch) {
        fetch(`${baseURL}/dashboard/get_country_wise_count?user_id=${id}&country=${country}&start_date=${startDate}&end_date=${endDate}&page=${page}&limit=${limit}`,
            HeaderAuthentication.getRequestOptions)
            .then((resp) => resp.json())
            .then((resp) => {
                const newData = [...reportDataCountryCount, ...resp.data];
                dispatch(getReportDataCountryCount(newData));
                dispatch(getToataldataCount(resp.total_count));
                setUploadCount(resp.grand_total)
                setLoading(false);
                setLoadingMore(false);
            })
            .catch((err) => {
                toast.error(`${err}`);
                console.log(err);
            });
    }
}
export const loadReportIndustryCountData = (id, industries, startDate, endDate, page, limit, setLoading, setLoadingMore, reportDataIndustryCount = [], setUploadCount) => {
    return function (dispatch) {
        fetch(`${baseURL}/dashboard/get_industry_wise_count?user_id=${id}&industry=${industries}&start_date=${startDate}&end_date=${endDate}&page=${page}&limit=${limit}`,
            HeaderAuthentication.getRequestOptions)
            .then((resp) => resp.json())
            .then((resp) => {
                const newData = [...reportDataIndustryCount, ...resp.data];
                dispatch(getReportDataIndustryCount(newData));
                dispatch(getToataldataCount(resp.total_count));
                setUploadCount(resp.grand_total)
                setLoading(false);
                setLoadingMore(false);
            })
            .catch((err) => {
                toast.error(`${err}`);
                console.log(err);
            });
    }
}
export const loadIndustryDropdown = (filterValue = '', setLoading) => {
    const queryParam = filterValue.trim()
        ? `?filter_value=${encodeURIComponent(filterValue)}`
        : '';

    return function (dispatch) {
        fetch(`${baseURL}/uploads/report_industry_dropdown${queryParam}`, HeaderAuthentication.getRequestOptions)
            .then((resp) => resp.json())
            .then((resp) => {
                const Industries = resp.data.map((industry) => ({
                    value: industry.industry,
                    label: industry.industry,
                }));
                dispatch(getIndustryDropdown(Industries));
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
            });
    };
};
// Data Count
// Report

// #region data report page
// #region get report data
export const loadGetReports = (user, month, year) => {
    return function (dispatch) {
        fetch(`${baseURL}/uploads/Upload_report?year=${year}&month=${month}&userid=${user}`, headerAuth)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 100) {
                    dispatch(getReportsData(resp));
                }
            })
            .catch((err) => {
                toast.error(`${err}`);
                console.log(err);
            });
    }
}
// #endregion

// #region get report data
export const loadGetUploadUser = () => {
    return function (dispatch) {
        fetch(`${baseURL}/uploads/get_upload_user`, headerAuth)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 100) {
                    dispatch(getUploadUsers(
                        resp.data.map((data) => {
                            return {
                                label: data.name,
                                value: data.id,
                            };
                        })
                    ));
                }
            })
            .catch((err) => {
                toast.error(`${err}`);
                console.log(err);
            });
    }
}
// #endregion
// #endregion

// Reset Password
export const postResetPasswordData = (
    postRequest,
    // cancelModal
    setSuccessMessage,
    setErrorMessage
) => {
    return function (dispatch) {
        fetch(`${baseURL}/lm_login/reser_password`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.success_code === 100) {
                    // dispatch(resetPassword());
                    setSuccessMessage(resp.message)
                    // cancelModal();
                    // Swal.fire({
                    //     title: 'Success',
                    //     text: resp.message,
                    //     icon: 'success',
                    // });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.message; // Extract error message
                    setErrorMessage(errorMessage);
                    // Swal.fire({
                    //     title: 'Failed',
                    //     text: errorMessage,
                    //     icon: 'error',
                    // });
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}
// Reset Password

// Forrgot Password
export const postForgotPassword = (
    postRequest,
    setSuccessMessage,
    setErrorMessage,
) => {
    return function (dispatch) {
        fetch(`${baseURL}/lm_login/reset_passwoed_link`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.success_code === 100) {
                    // Dispatch the action to update the store (you may already have this action)
                    dispatch(postForgotPasswordEmail());
                    setSuccessMessage(resp.message);

                } else {
                    console.error("Send Reset-Password link failed:", resp.Msg);
                    setErrorMessage(resp.error);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
};
// Forrgot Password

// Profile
export const loadProfileData = (userId, setLoading) => {
    return function (dispatch) {
        fetch(`${baseURL}/Users/get_user_profile?user_id=${userId}`, HeaderAuthentication.getRequestOptions)
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getProfileData(resp));
                setLoading(false)
            })
            .catch((err) => {
                toast.error(`${err}`);
                console.log(err);
            });
    }
}
export const postProfileUpdate = (
    postRequest,
    fetchProfileData,
    cancelModal
) => {
    return function (dispatch) {
        fetch(`${baseURL}/Users/update_profile`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 100) {
                    fetchProfileData();
                    cancelModal(false);
                    Swal.fire({
                        title: 'Success',
                        text: resp.message,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.message;
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}

export const postAddressDataData = (
    postRequest,
    fetchProfileData,
    cancelModal
) => {
    return function (dispatch) {
        fetch(`${baseURL}/Users/update_address`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 100) {
                    dispatch(addAddressData());
                    fetchProfileData();
                    cancelModal(false);
                    Swal.fire({
                        title: 'Success',
                        text: resp.message,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.message;
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}
// Profile

// #region logout function
export const logoutFunction = (postRequest) => {
    return function (dispatch) {
        fetch(`${baseURL}/lm_login/set_logout`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 100) {
                    sessionStorage.clear();
                    window.location.href = '/';
                }
            })
            .catch((err) => {
                toast.error(`${err}`);
                console.log(err);
            });
    }
}
// #endreion

// My List
export const loadMyListData = (signInID, sbnID, role, currentPage, limit, setLoading) => {
    return function (dispatch) {
        fetch(`${baseURL}/lists/get_user_lists?sbn_id=${sbnID}&fk_user_id=${signInID}&role=${role}&page=${currentPage}&limit=${limit}`, HeaderAuthentication.getRequestOptions)
            .then((resp) => resp.json())
            .then((resp) => {
                dispatch(getMyListData(resp.data));
                if (setLoading) {
                    setLoading(false)
                }
            })
            .catch((err) => {
                toast.error(`${err}`);
                console.log(err);
            });
    }
}

export const updateMyListData = (
    postRequest,
    fetchMyListData,
    cancelModal
) => {
    return function (dispatch) {
        fetch(`${baseURL}/lists/edit_list`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 100) {
                    dispatch(editMyListData());
                    fetchMyListData();
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.message,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.message;
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}
export const deleteMyListData = (
    postRequest,
    fetchMyListData,
    cancelModal
) => {
    return function (dispatch) {
        fetch(`${baseURL}/lists/delete_list`, postRequest)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 100) {
                    dispatch(deleteMyList());
                    fetchMyListData();
                    cancelModal();
                    Swal.fire({
                        title: 'Success',
                        text: resp.message,
                        icon: 'success',
                    });
                } else {
                    // toast.error(resp.Error);
                    const errorMessage = resp.message;
                    Swal.fire({
                        title: 'Failed',
                        text: errorMessage,
                        icon: 'error',
                    });
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}
// My List


// region connect to ai
export const setAiModal = (isOpen) => ({
    type: "Open_Ai_Modal",
    payload: isOpen,
});
export const setAiLoader = (openAiLoader) => ({
    type: "Open_Ai_Loader",
    payload: openAiLoader,
});
export const connectAiApp = (postRequest) =>
    async (dispatch) => {
        try {
            const res = await fetch(`${aiBaseUrl}api/plugin/login`, postRequest);

            const data = await res.json();
            dispatch(setAiModal(true))
            return data;
        } catch (err) {
            console.log(err);
        }
    }
// endregion


// region upgrade api call
export const loadUpgradePlan = (requestOption) => {
    return function (dispatch) {
        return fetch(`${baseURL}/Users/upgrade_subscription`, requestOption)
            .then((resp) => resp.json())
            .then((resp) => {
                return resp
            })
            .catch((err) => { console.log(err) });
    }
}
// endregion

// region call delete api
export const loadDeleteAccount = (requestOption) => {
    return function (dispatch) {

        return fetch(`${baseURL}/Users/delete_account`, requestOption)
            .then((resp) => resp.json())
            .then((resp) => {
                return resp
            })
            .catch((err) => { console.log(err) });
    }
} 




// =====================================================
// GET default provider
// =====================================================
export const getDefaultProvider = () => {
  return async (dispatch) => {
    try {
      const response = await fetch(`${aiBaseUrl}ai/get-default-provider`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (data?.status === 200 || data?.default_provider) {
        const provider = data.default_provider || "apollo";
        return provider;
      }

      return "apollo";
    } catch (error) {
      console.error("getDefaultProvider error:", error);
      return "apollo";
    }
  };
};

// =====================================================
// UPDATE default provider (super-admin only)
// =====================================================
export const updateDefaultProvider = (provider) => {
  return async (dispatch) => {
    try {
      const signInDetails = JSON.parse(
        sessionStorage.getItem("SignInDetails") || "[]"
      );

      const payload = {
        provider: provider, // "apollo" | "salestarget"
        user_id: parseInt(signInDetails[0]?.id || 0),
        user_name: signInDetails[0]?.name || "Admin",
      };

      const response = await fetch(`${aiBaseUrl}ai/set-default-provider`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (data?.status === 200) {
        toast.success(
          data.message || `Default provider updated to ${provider}`
        );
        return data;
      }

      toast.error(data?.message || "Failed to update provider");
      throw new Error(data?.message || "Update failed");
    } catch (error) {
      console.error("updateDefaultProvider error:", error);
      toast.error("Failed to update default provider");
      throw error;
    }
  };
};

export const getRecentSearchData = (data) => ({
  type: "GET_RECENT_SEARCH",
  payload: data,
});

export const loadRecentSearches = (userId, sbnId, role, page = 1, limit = 20) => {
  return function (dispatch) {
    const params = new URLSearchParams({
      user_id: String(userId),
      sbn_id: String(sbnId),
      role: String(role || "user"),
      page: String(page),
      limit: String(limit),
    });

    return fetch(
      `${baseURL}/dashboard/get_recent_search?${params}`,
      HeaderAuthentication.getRequestOptions
    )
      .then((resp) => resp.json())
      .then((resp) => {
        console.log("get_recent_search =>", resp);

        if (resp.status_code === 100) {
          const list = (resp.data || []).map((row) => {
            // Normalize search_data if API returns a string
            let searchData = row.search_data;
            if (typeof searchData === "string") {
              try {
                searchData = JSON.parse(searchData);
              } catch {
                searchData = { search_criteria: searchData };
              }
            }
            return {
              ...row,
              search_data: searchData || {},
              provider: (
                row.provider ||
                searchData?.provider ||
                "apollo"
              ).toLowerCase(),
            };
          });

          dispatch(getRecentSearchData(list));
          return list;
        }

        dispatch(getRecentSearchData([]));
        return [];
      })
      .catch((err) => {
        console.log(err);
        dispatch(getRecentSearchData([]));
      });
  };
};


// endregion